<template>
  <div id="competition">
    <template v-if="category">
      <Category :item="category"></Category>
    </template>
    <template v-else>
      <div class="categories">
        <router-link
          v-for="category in categories"
          :key="category.id"
          class="item"
          :to="'competition/' + category.id"
        >
          <div class="name">{{ category.name }}</div>
          <div class="description">{{ category.year }}</div>
        </router-link>
      </div>
    </template>

    <template v-if="sponsor">
        <img
        class="sponsor"
        :src="sponsor"
        loading="lazy"
        height="300"
      />
    </template>
  </div>
</template>

<script>
import Category from "@/components/domain/competition/category";

export default {
  name: "Competition",
  components: { Category },
  data() {
    return {
      categoryId: false,
    };
  },
  computed: {
    categories() {
      return this.$store.getters["competition/getCategories"]();
    },
    category() {
      return this.categories[this.categoryId];
    },
    sponsor() {
      var result = this.$store.getters["getSponsors"]("competition");
      return result || false;
    },
  },
  methods: {
    load() {
      if (this.$route.params.id) {
        this.categoryId = this.$route.params.id;
      } else {
        this.categoryId = false;
      }
    },
  },
  created() {},
  mounted() {
    this.load();
  },
  watch: {
    "$route.params": {
      handler: function (newValue, value) {
        this.load();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.categories {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  row-gap: 10px;
  text-align: center;

  .item {
    background-color: $main-color;
    color: #fff;
    border-radius: 4px;
    padding: 35px 10px;
    align-items: center;
    display: flex;
    flex-direction: column;
    text-decoration: none;
    .name {
      font-family: $font-title;
      font-size: 24px;
    }
    .description {
    }
  }
}

.tablet {
  .categories {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.laptop {
  .categories {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(
        0,
        1fr
      ) !important;
  }
}
.desktop {
  .categories {
    grid-template-columns:
      minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)
      minmax(0, 1fr) !important;
  }
}
</style>
